export default __webpack_public_path__ + "static/media/groupCircleCoreDrive.a44074b0.svg";